import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import NavMenu from './NavMenu';

import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Calculation";
import config from "../common/Config";
import ReactAI from 'react-appinsights';
import {history} from "../index";

type Props = {
    requestUserAuth: Function,
    requestHistory: Function,
    userAuthsIsLoading: boolean,
    historyIsLoading: boolean,
}

class Layout extends React.Component<Props> {

    componentDidMount() {
        if(!this.props.userAuthsIsLoading /*&& !window.location.href.includes("localhost")*/) {
            this.props.requestUserAuth();
            history.push("/login");
        }
    }
    
    render() {
        
        return (<div className="layout">
            <NavMenu />
    
            <div className="tree"></div>

            <div className="main-content">
    
                <Container>
                    <Row>
                        <Col>
                            {this.props.children}
                        </Col>
                    </Row>
                </Container>

            </div>

            
        </div>);
    }

}

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Layout));



// WEBPACK FOOTER //
// ./src/components/Layout.js